import React from 'react';
import clsx from 'clsx';

const DotIcon = (props) => {
    const { color } = props;

    return !!color && (
        <span
            className={clsx(
                'w-[10px] h-[10px] rounded-full inline-block',
                { 'bg-gray-dark01': color === 'cancel' },
                { 'bg-gray-dark02': color === 'none' },
                { 'bg-primary': color === 'info' },
                { 'bg-success': color === 'success' },
                { 'bg-warning': color === 'warning' },
                { 'bg-danger': color === 'error' },
                { 'bg-purple': color === 'special' }
            )}
            style={{ background: color?.startsWith('#') ? color : undefined }}
        />
    );
};

export default DotIcon;
